export default __webpack_public_path__ + "../img/29449dfe164962cf03bb69a576233e16.png";